export default __webpack_public_path__ + "static/media/ayuda.5b6856e4.png";